import React, { createContext, useContext } from 'react';
import { Status, useScript } from '../../hooks/useScript';
import { useConfigContext } from '../../config/ConfigContext';
import { IWebshopContext } from './types';

export type { Status } from '../../hooks/useScript';

const webshopRoot = 'root';
const selfServiceIntegration = '/static/js/selfServiceIntegration.js';
const WebshopContext = createContext<IWebshopContext | undefined>(undefined);

export const WebshopProvider: React.FC<{ statusOverride?: Status }> = ({
  children,
  statusOverride,
}) => {
  const config = useConfigContext();
  const host = config?.webshop.host;
  const webshopSrc = host && host + selfServiceIntegration;
  const status = useScript({ src: webshopSrc, id: 'webshop' }, () =>
    window.WebshopApp?.render(webshopRoot),
  );

  return (
    <WebshopContext.Provider value={{ ...window.WebshopApp, status: statusOverride || status }}>
      {children}
      <div id={webshopRoot} />
    </WebshopContext.Provider>
  );
};

export const useWebshop = () => {
  const context = useContext(WebshopContext);

  if (!context) {
    throw new Error('useWebshop must be within WebshopProvider');
  }

  return context;
};
